import { defineMessages } from 'react-intl';

export const scope = 'app.components.assign_proctor';

export default defineMessages({
  no_user_found: {
    id: `${scope}.no_user_found`,
    defaultMessage: 'No User Found',
  },
  sessions_selected: {
    id: `${scope}.sessions_selected`,
    defaultMessage: '{count} sessions selected',
  },
  assign_proctor: {
    id: `${scope}.assign_proctor`,
    defaultMessage: 'Assign Proctor',
  },
  select_proctor_placeholder: {
    id: `${scope}.select_proctor_placeholder`,
    defaultMessage: 'Select a proctor...',
  },
  due_date: {
    id: `${scope}.due_date`,
    defaultMessage: 'Due Date',
  },
  sessions: {
    id: `${scope}.sessions`,
    defaultMessage: 'Sessions',
  },
  in_progress: {
    id: `${scope}.in_progress`,
    defaultMessage: 'In Progress',
  },
  will_not_be_assigned: {
    id: `${scope}.will_not_be_assigned`,
    defaultMessage: ' will not be assigned.',
  },
  go_back: {
    id: `${scope}.go_back`,
    defaultMessage: 'Go Back',
  },
  save_changes: {
    id: `${scope}.save_changes`,
    defaultMessage: 'Save Changes',
  },
  request_review: {
    id: `${scope}.request_review`,
    defaultMessage: 'Request Review',
  },
});
